import React from 'react';
import Paper from '@mui/material/Paper';
import $ from 'jquery';
import uniqid from 'uniqid';

import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import CircularProgress  from '@mui/material/CircularProgress';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import AddIcon from '@mui/icons-material/NoteAdd';
import ActionDelete from '@mui/icons-material/Delete';
import ErrorIcon from '@mui/icons-material/Error';
import grey from '@mui/material/colors/grey';
import red from '@mui/material/colors/red';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Alert from '@mui/material/Alert';

//import Help from '../Components/Help'
import {addFile, updateFileStatus, removeFile} from '../Actions'

const conf = {
  dateinameMaxLength:15,
}

const styles = {
  row: {
    display: 'flex',
    justifyContent: 'center',
  },
  imageInput: {
    display:'none',
  },
  docContainer: {
    display:"block",
    float:"left",
    width:"200px",
    marginRight:"20px",
    marginBottom:"20px",
    backgroundColor:grey[100],
  },
  filetypeAvatar: {
    marginTop:'15px',
    width:'60px',
    height:'auto',
  },
  center: {
    textAlign:'center',
  },
  clear: {
    clear:'left',
  },
  status: {
    height:'25px',
    paddingTop:'25px',
    paddingBottom:'0px',
    marginBottom:'0px',
    paddingRight:'8px',
    paddingLeft:'8px',
    textAlign:'center',
  },
  icons: {
    height:'50px',
    textAlign:'center',
  },
  dateinameTitel: {
    textAlign:'center',
    marginTop:'3px',
  },
  dateinameText: {
    height:'40px',
    paddingTop:'5px',
    textAlign:'center',
    fontSize:"120%",
  },
  dateinameInput: {
    height:'50px',
    marginTop:'-5px',
    textAlign:'center',
    paddingLeft:'20px',
    paddingRight:'20px',
  },
  extension: {
    color:grey[500],
  },
  helpBlock: {
    position:'relative',
  },
};

export default class DokumenteUploader extends React.Component {

  prepareUpload = (event) => {
    let files = event.target.files

    Object.keys(files).map(
      (index) => files[index].uid = this.getNewDocId()
    )

    this.registerFiles(files)
    this.uploadFiles(files)
  }

  getNewDocId = () => {
    return uniqid.time()
  }

  uploadFiles = (files) => {
    var data = new FormData();
    $.each(files, function(key, value)
    {
        let id = value.uid
        data.append(key, value, id);
    })

    $.ajax({
        url: this.props.restPath+'dokumenteUpload.php?files',
        xhrFields: {
          withCredentials: true
        },
        type: 'POST',
        data: data,
        cache: false,
        dataType: 'json',
        context: this,
        processData: false, // Don't process the files
        contentType: false, // Set content type to false as jQuery will tell the server its a query string request
        success: function(data, textStatus, jqXHR)
        {
          this.updateStatus(data)
        },
        error: function(jqXHR, textStatus, errorThrown)
        {
            // Handle errors here
            // STOP LOADING SPINNER
        }
    });
  }

  removeFile = (id) => {
    $.ajax({
        url: this.props.restPath+'dokumenteRemove.php?docId='+id,
        xhrFields: {
          withCredentials: true
        },
        type: 'POST',
        cache: false,
        dataType: 'json',
        processData: false,
        contentType: false,
        success: function(data, textStatus, jqXHR)
        {
            if( typeof data.error === 'undefined')
            {
            }
            else
            {
            }
        },
        error: function(jqXHR, textStatus, errorThrown)
        {
        }
    });
  }

  handleRemoveImg = (imgUid) => {
    this.props.dispatch(removeFile(this.props.lineage, imgUid))
    this.setState({files:{}})
    this.removeFile(imgUid)
  }

  registerFiles = (files) => {
    Object.keys(files).map(
      (index) => {
        var imageUid = files[index].uid
        var filename = files[index].name.split('.')
        var extension = filename.pop()
        var name = filename.join('.')
        if (!name) {
          name = "Unbenannt"
        }

        this.props.dispatch(
          addFile(
            this.props.lineage,
            name,
            extension,
            imageUid,
            'upload',
            null
          )
        )
      }
    )
  }

  updateStatus = (report) => {
    report.map(
      (obj) => {
        let status = 'error'
        let message = null
        if (obj.message) {
          message = obj.message
        }
        
        if (obj.status == 'success') {
          status = 'ok'
        }
        this.props.dispatch(
          updateFileStatus(
            this.props.lineage,
            obj.id,
            status,
            message
          )
        )
      }
    )
  }

  renderDocs = (id, statusCode, name, extension, message) => (
    <TableRow 
      key={"docs_"+id}
    >
      <TableCell>
        {statusCode == 'upload' &&
           <CircularProgress mode="indeterminate" size={18} />
        }

        {statusCode == 'ok' &&
          <CheckCircleOutlineIcon 
            style={{ color:"#339933", display: "inline-block", marginBottom:"-4px" }}
          />
        }

        {statusCode == 'error' &&
           <ErrorIcon style={{color:red[500]}} size={18} />
        }

      </TableCell>
      <TableCell>
        {name}.{extension} 
        {message&&
          <Alert icon={false} severity="error">{message}</Alert>
        }
      </TableCell>
      <TableCell align="right">
        {(statusCode == 'ok' || statusCode == 'error') &&
          <IconButton sx={{ '& .MuiSvgIcon-root': { fontSize: 28 }}}
            tooltip="Löschen"
            onClick={() => this.handleRemoveImg(id)}
          >
            <ActionDelete />
          </IconButton>
        }
      </TableCell>

    </TableRow >
  )

  readDocs = () => {
    var arr = []

    Object.keys(this.props.dokumente).map(
      (key) => {
        arr.push(
          this.renderDocs(
            this.props.dokumente[key].id,
            this.props.dokumente[key].statusCode,
            this.props.dokumente[key].name,
            this.props.dokumente[key].extension,
            this.props.dokumente[key].message,
            
          )
        )
      }
    )

    return arr
  }

  render(){
    return(
      <div style={this.props.style}>
        <Paper>
        {Object.keys(this.props.dokumente).length > 0 &&
          <Table size="small">
            <TableBody>
              <TableRow>
                <TableCell  colSpan={3}>{(this.props.label)?<b>{this.props.label}</b>:<b>Beigefügte Dokumente</b>}</TableCell>
              </TableRow>
              {this.readDocs()}
            </TableBody>
          </Table>
          }
          <div style={styles.clear}></div>
            <input
              type="file"
              style={styles.imageInput}
              id={"documentFileSelect"+this.props.lineage.join('-')}
              name={"documentFileSelect"+this.props.lineage.join('-')}
              onChange={this.prepareUpload}
              accept={
                '.pdf, application/pdf'+
                ', .jpg, image/jpg'+
                ', .jpeg, image/jpeg'+
                ', .png, image/png'+
                ', .doc, application/msword'+
                ', .docx, application/vnd.openxmlformats-officedocument.wordprocessingml.document'+
                ', .xls, application/vnd.ms-excel'+
                ', .xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'+
                ', .odt, aapplication/vnd.oasis.opendocument.text '
              }
              multiple
            />
            {Object.keys(this.props.dokumente).length > 0 &&
              <label htmlFor={"documentFileSelect"+this.props.lineage.join('-')}>
                <Button
                  component="span"
                  color="primary"
                  style={{margin:"10px"}}
                >
                  <AddIcon /> &nbsp;Weitere Dokumente hinzufügen
                </Button>
              </label>
            }
          </Paper>

          {Object.keys(this.props.dokumente).length < 1 &&
            <label htmlFor={"documentFileSelect"+this.props.lineage.join('-')}>
              <Button
                component="span"
                color="primary"
                variant={(this.props.buttonVariant)?this.props.buttonVariant:"text"}
                size={(this.props.buttonSize)?this.props.buttonSize:"medium"}
                fullWidth={(this.props.buttonFullWidth)?true:false}

              >
                <AddIcon /> &nbsp;{(this.props.labelButton)?<span>{this.props.labelButton}</span>:<span>Dokumente hinzufügen</span>}
              </Button>
            </label>
          }

      </div>
    );
  }
}

